import React from 'react';
import { useHistory } from 'react-router-dom';

import { Box, Button, Grid, Link, Typography } from '@material-ui/core';

import { useAssistanceDataContext } from '../../../../context/assistance/assistance.provider';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';

const StatusRejected = () => {
  const history = useHistory();
  const { success } = useAssistanceDataContext();
  const { assistance_status } = success;

  const { embed } = useAuthDataContext();
  const redirectHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  return (
    <Grid item xs={11}>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: '100%' }}
      >
        <Grid item xs={12}>
          <Box my={4} textAlign="center">
            <Typography variant="h6">
              ¡Tu pedido de asistencia fue rechazado!
            </Typography>
          </Box>
          <Box my={2} textAlign="center">
            <Typography component="span">Por consultas llamá a </Typography>
            <Link
              href={`tel:${assistance_status.provider_phone}`}
              rel="noopener"
              target="_blank"
            >
              <Typography
                component="span"
                display="inline"
                align="left"
                color="secondary"
              >
                {assistance_status.provider_phone}
              </Typography>
            </Link>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Grid container justify="center">
            <Grid item xs={6} md={4}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={redirectHome}
              >
                Volver a inicio
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default StatusRejected;
